
import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'

export const CustomLink = styled(Link)`
    margin-left: 4px;
    display: contents;
    font-size: 13px;
    color: ${({ themeColor }) => themeColor?.titles?.highlight?.textColor ?? '#000'} !important;

`
